import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import {Formik} from "formik";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import QButton from "../../../../common/components/QButton";
import QSelect from "../../../../common/components/QSelect";
import SetupApi from "../../../../common/api/functions/Setup";
import {config} from "../../../../config";
import {setToast} from "../../../../app/rootReducer";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {SetupInterface} from "../../../../interfaces/private/SetupInterface";
import {SelectOptionInterface} from "../../../../interfaces/SelectOptionInterface";

interface Props {
    model: SetupInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setSetup: Function,
    setup: SetupInterface,
    allDataSetup: any,
}

const BodyRefundSetupComponent: React.FC<Props> = ({
    allDataSetup,
    setOpen,
    setLoadingFunc,
    setSetup,
    setup,
}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const bookedWiths = allDataSetup?.bookedWiths || {};
    const isLedger = (setup.accounting_mode || "invoice_matching") === "customer_balance_ledger";

    useEffect(() => {
        if (loading) {
            SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(response?.data?.data || {});
                }
            }).finally(async () => {
                await setLoading(false);
            });
        }
    }, [loading]);

    return (
        <React.Fragment>
            <Formik
                enableReinitialize
                initialValues={{
                    ...setup,
                    economic_refund_booked_with: setup.economic_refund_booked_with || "1",
                }}
                onSubmit={(values: any) => {
                    SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            setSetup(response?.data?.data || {});
                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: t("economic.updateSuccess"),
                                type: config.TOAST_TYPE.SUCCESS,
                            }));
                        }
                    });
                }}
            >
                {(formik) => (
                    <React.Fragment>
                        <Row>
                            <Col>
                                {isLedger ? (
                                    <div className="alert alert-info py-2 mb-0" role="status">
                                        {t("economic.sectionRefundHelpLedger")}
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <p className="text-muted small mb-3">{t("economic.sectionRefundHelp")}</p>
                                        <QSelect
                                            menuPortal
                                            label={t("economic.refundBookedWith")}
                                            value={formik.values.economic_refund_booked_with}
                                            onChange={(option: SelectOptionInterface) => {
                                                formik.setFieldValue("economic_refund_booked_with", option.value);
                                            }}
                                            options={Object.entries(bookedWiths).map(([key, value]) => ({
                                                label: value as string,
                                                value: key,
                                            }))}
                                        />
                                        <p className="text-muted small mb-0">
                                            {String(formik.values.economic_refund_booked_with) === "2"
                                                ? t("economic.refundBookedWithAutoHelp")
                                                : t("economic.refundBookedWithManualHelp")}
                                        </p>
                                    </React.Fragment>
                                )}
                            </Col>
                        </Row>
                        <div className="text-end mt-3">
                            <QButton
                                type="secondary"
                                onClick={() => setOpen(false)}
                                content={t("common.button.cancel")}
                            />
                            {!isLedger ? (
                                <QButton
                                    type="primary"
                                    onClick={() => formik.handleSubmit()}
                                    content={t("common.button.save")}
                                />
                            ) : null}
                        </div>
                    </React.Fragment>
                )}
            </Formik>
        </React.Fragment>
    );
};

export default BodyRefundSetupComponent;
